import { useNetWorkListener } from './listenNetWorkHook';
import { useStreamListener } from './listenStreamHook';
import { useRtcErrorListener } from './listenTrcErrorHook';
import { useRtcBannedListener } from './listenTrtcBannedHook';

export const useListener = () => {
  useNetWorkListener();
  useStreamListener();
  useRtcErrorListener();
  useRtcBannedListener();
};
